import { GlobalModalTypes } from './components/GlobalModals/GlobalModalContainer'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'
// audio
import LobbyMusic from './images/audio/lobby.mp3'
import Auditorium from './images/backdrops/auditorium.jpg'
import CountdownM from './images/backdrops/countdownM.jpg'
// backdrops
import { default as Countdown, default as Entrance } from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/entranceP.jpg'
import Exhibition from './images/backdrops/exhibition.jpg'
import Gallerium from './images/backdrops/gallerium.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import AuditoriumM from './images/backdrops/mobile-auditorium.jpg'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import LobbyM from './images/backdrops/space.jpg'
import VirtualProductLandingPage from './images/backdrops/theatre-landing.jpg'
import VirtualProductLandingPageP from './images/backdrops/theatre-landingP.jpg'
import Theatre from './images/backdrops/theatre.jpg'
import TheatreP from './images/backdrops/theatreP.jpg'
// icons & decorations
import faqIcon from './images/help.png'
import hoverEffect from './images/hover.gif'
import menarini from './images/lobbyEntry/a-menarini.png'
import arthrotech from './images/lobbyEntry/arthrotech.png'
import auditoriumDoorClose from './images/lobbyEntry/auditorium-door-close.png'
import auditoriumDoorOpen from './images/lobbyEntry/auditorium-door-open.png'
import ciMed from './images/lobbyEntry/cimed.png'
import galleryDoorClose from './images/lobbyEntry/gallery-door-close.png'
import galleryDoorOpen from './images/lobbyEntry/gallery-door-open.png'
import HandUpHover from './images/lobbyEntry/hand-up-hover.png'
import HandUpNormal from './images/lobbyEntry/hand-up-nor.png'
import iconMedic from './images/lobbyEntry/Icon-medic.png'
import InfoIcon from './images/lobbyEntry/infoIcon.png'
import malexMedic from './images/lobbyEntry/malex-medic.png'
import medicWave from './images/lobbyEntry/medicwave.png'
import philosmed from './images/lobbyEntry/philosmed.png'
import primo from './images/lobbyEntry/primo.png'
import smithNNephew from './images/lobbyEntry/smith-n-nephew.png'
import wellchem from './images/lobbyEntry/wellchem.png'
import routes from './routes'

const dev = {
  // apiUrl: 'http://localhost:3000',
  apiUrl: 'https://masconference.com',
}

const prod = {
  apiUrl: 'https://masconference.com',
}

const API_KEYS = {
  amplitude: '4df75fbd173ec1c43aa9a57f685d5221',
}

const VOLUME_VALUE = 0.4

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2021,
  month: 10,
  day: 15,
  hour: 6,
  minute: 0,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  countdown: {
    landscape: Countdown,
    portrait: CountdownM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,
  landing: {
    landscape: VirtualProductLandingPage,
    portrait: VirtualProductLandingPageP,
  },
  theatre: {
    landscape: Theatre,
    portrait: TheatreP,
  },
}

const layout = {
  auditoriumVid: `
    top: 17.5%;
    bottom: 41.5%;
    left: 20%;
    right: 39%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  // {
  //   id: 'gameroom',
  //   type: LobbyEntryTypes.DirectRoute,
  //   destination: routes.networking,
  //   entryOpenImage: openRightGlassDoor,
  //   entryCloseImage: closeRightGlassDoor,
  //   css: `
  //     top: 0%;
  //     left: 66.4%;
  //     right: 26%;
  //     bottom: 63.8%;
  //   `,
  // },
  {
    id: 'malex',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.malexbooth,
    entryOpenSponsor: malexMedic,
    entryCloseSponsor: malexMedic,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 55.6%;
      left: 72%;
      right: 17.9%;
      bottom: 34.5%;
    `,
  },
  {
    id: 'smithNNephew',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.smithbooth,
    entryOpenSponsor: smithNNephew,
    entryCloseSponsor: smithNNephew,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 58.6%;
      left: 18%;
      right: 73.7%;
      bottom: 38.5%;
    `,
  },
  {
    id: 'medicWave',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.medicwavebooth,
    entryOpenSponsor: medicWave,
    entryCloseSponsor: medicWave,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 28.6%;
      left: 19.5%;
      right: 75.4%;
      bottom: 67.5%;
    `,
  },
  {
    id: 'primo',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.primobooth,
    entryOpenSponsor: primo,
    entryCloseSponsor: primo,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 28.6%;
      left: 29%;
      right: 66.2%;
      bottom: 67.5%;
    `,
  },
  {
    id: 'philosMed',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.philosmedbooth,
    entryOpenSponsor: philosmed,
    entryCloseSponsor: philosmed,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 27%;
      left: 65%;
      right: 29.5%;
      bottom: 65.7%;
    `,
  },
  {
    id: 'wellchem',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.wellchembooth,
    entryOpenSponsor: wellchem,
    entryCloseSponsor: wellchem,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 28%;
      left: 74.5%;
      right: 20.5%;
      bottom: 66.5%;
    `,
  },
  {
    id: 'ciMed',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.ciMedbooth,
    entryOpenSponsor: ciMed,
    entryCloseSponsor: ciMed,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 43.3%;
      left: 30.5%;
      right: 66.4%;
      bottom: 51%;
    `,
  },
  {
    id: 'menarini',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.menarinibooth,
    entryOpenSponsor: menarini,
    entryCloseSponsor: menarini,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 43.6%;
      left: 41.5%;
      right: 53.8%;
      bottom: 52.5%;
    `,
  },
  {
    id: 'iconMedic',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.iconMedicbooth,
    entryOpenSponsor: iconMedic,
    entryCloseSponsor: iconMedic,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 42.8%;
      left: 53.5%;
      right: 41.8%;
      bottom: 51%;
    `,
  },
  {
    id: 'arthrotech',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.arthrotechbooth,
    entryOpenSponsor: arthrotech,
    entryCloseSponsor: arthrotech,
    pinImage: hoverEffect,
    // pinText: 'Click To Visit Booth',
    css: `
      top: 44%;
      left: 65.5%;
      right: 29.5%;
      bottom: 52.5%;
    `,
  },
  {
    id: 'auditorium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.auditorium1,
    entryOpenImage: auditoriumDoorOpen,
    entryCloseImage: auditoriumDoorClose,
    css: `
      top: 53.6%;
      left: 42.1%;
      right: 43.1%;
      bottom: 33.5%;
    `,
  },
  {
    id: 'networking',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.networking,
    entryOpenImage: galleryDoorOpen,
    entryCloseImage: galleryDoorClose,
    css: `
      top: 55.3%;
      left: 32.3%;
      right: 61.7%;
      bottom: 33.4%;
    `,
  },
  {
    id: 'gallerium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.onDemand,
    entryOpenImage: galleryDoorOpen,
    entryCloseImage: galleryDoorClose,
    css: `
      top: 55.3%;
      left: 61.1%;
      right: 32.9%;
      bottom: 33.4%;
    `,
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    pinIcon: InfoIcon,
    css: `
      top: 68%;
      left: 53%;
      right: 41%;
      bottom: 25.5%;
    `,
  },
  {
    id: 'sample-global-modal-lobby-entry-please-delete',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.CPD,
    // pinText: 'I am Table',
    // pinImage: PinIcon,
    entryOpenImage: HandUpHover,
    entryCloseImage: HandUpNormal,
    css: `
      top: 76%;
      left: 87%;
      right: 6%;
      bottom: 9.5%;
    `,
  },
  {
    id: 'faq',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.FAQ,
    entryOpenImage: faqIcon,
    entryCloseImage: faqIcon,
    css: `
      top: 71%;
      left: 62%;
      right: 36%;
      bottom: 24.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,

  eventName: '8th MAS ASM 2021',

  ...config,
}
